<div
  class="loading-overlay"
  [class.loading-overlay--exit]="fadeOut()"
  role="status"
  [attr.aria-label]="'Cargando ' + title()"
>
  <div class="loader-stage">
    <div class="machinery-wrapper" [class.is-hidden]="hideMachinery()">
      <svg viewBox="0 0 800 500">
        <defs>
          <filter id="shadow">
            <feDropShadow dx="5" dy="8" stdDeviation="6" flood-color="#000" flood-opacity="0.8" />
          </filter>
          <filter id="glow">
            <feDropShadow dx="0" dy="0" stdDeviation="5" flood-color="#8B3D3D" flood-opacity="1" />
          </filter>
        </defs>

        <g filter="url(#shadow)">
          <g class="gear-left">
            <circle cx="200" cy="250" r="160" fill="none" stroke="#D1D5DB" stroke-width="20"
              stroke-dasharray="30 20" />
            <circle cx="200" cy="250" r="135" fill="none" stroke="#D1D5DB" stroke-width="35" />
            <circle cx="200" cy="250" r="80" fill="none" stroke="#D1D5DB" stroke-width="10" />
            <circle cx="200" cy="250" r="50" fill="none" stroke="#D1D5DB" stroke-width="2"
              opacity="0.3" />
          </g>
        </g>

        <g filter="url(#shadow)" fill="#D1D5DB">
          <rect x="330" y="380" width="35" height="12" rx="2" />
          <rect x="375" y="380" width="50" height="12" rx="2" />
          <rect x="435" y="380" width="35" height="12" rx="2" />
          <rect x="310" y="400" width="40" height="12" rx="2" />
          <rect x="360" y="400" width="80" height="12" rx="2" />
          <rect x="450" y="400" width="40" height="12" rx="2" />
          <rect x="340" y="420" width="50" height="12" rx="2" />
          <rect x="410" y="420" width="50" height="12" rx="2" />
        </g>

        <g filter="url(#shadow)">
          <polygon points="350,360 450,360 460,340 340,340" fill="#D1D5DB" stroke="#D1D5DB"
            stroke-width="2" stroke-linejoin="round" />
          <polygon points="360,340 440,340 420,290 380,290" fill="#D1D5DB" stroke="#D1D5DB"
            stroke-width="2" stroke-linejoin="round" />
          <line x1="375" y1="315" x2="425" y2="315" stroke="#475467" stroke-width="4"
            stroke-linecap="round" />
          <line x1="385" y1="300" x2="415" y2="300" stroke="#475467" stroke-width="4"
            stroke-linecap="round" />
        </g>

        <g filter="url(#shadow)">
          <g class="gear-right-1">
            <circle cx="600" cy="360" r="50" fill="none" stroke="#D1D5DB" stroke-width="16"
              stroke-dasharray="15 10" />
            <circle cx="600" cy="360" r="35" fill="none" stroke="#D1D5DB" stroke-width="14" />
            <circle cx="600" cy="360" r="15" fill="none" stroke="#D1D5DB" stroke-width="4" />
          </g>
          <g class="gear-right-2">
            <circle cx="680" cy="400" r="30" fill="none" stroke="#D1D5DB" stroke-width="12"
              stroke-dasharray="10 8" />
            <circle cx="680" cy="400" r="20" fill="none" stroke="#D1D5DB" stroke-width="8" />
          </g>
        </g>

        <path d="M 570 330 A 42 42 0 0 1 630 330" fill="none" stroke="#A48E69" stroke-width="3"
          stroke-linecap="round" />
        <path d="M 660 380 A 25 25 0 0 1 700 380" fill="none" stroke="#A48E69" stroke-width="2"
          stroke-linecap="round" />

        <g class="mech-arm-left">
          <g filter="url(#shadow)">
            <path d="M 380 290 L 260 180 L 200 240" fill="none" stroke="#D1D5DB" stroke-width="32"
              stroke-linejoin="round" stroke-linecap="round" />
            <path d="M 370 280 L 260 180 L 210 230" fill="none" stroke="#475467" stroke-width="4"
              stroke-linejoin="round" stroke-linecap="round" />
            <path d="M 195 240 L 175 265 L 185 285" fill="none" stroke="#D1D5DB" stroke-width="10"
              stroke-linejoin="round" stroke-linecap="round" />
            <path d="M 205 240 L 225 265 L 215 285" fill="none" stroke="#D1D5DB" stroke-width="10"
              stroke-linejoin="round" stroke-linecap="round" />
          </g>
          <path d="M 240 150 A 35 35 0 0 1 290 170" fill="none" stroke="#A48E69" stroke-width="3"
            stroke-linecap="round" />
          <circle cx="380" cy="290" r="8" fill="#8B3D3D" filter="url(#glow)" />
          <circle cx="260" cy="180" r="8" fill="#8B3D3D" filter="url(#glow)" />
          <circle cx="200" cy="240" r="5" fill="#8B3D3D" filter="url(#glow)" />
        </g>

        <g class="mech-arm-right">
          <g filter="url(#shadow)">
            <path d="M 420 290 L 540 180 L 600 240" fill="none" stroke="#D1D5DB" stroke-width="32"
              stroke-linejoin="round" stroke-linecap="round" />
            <path d="M 430 280 L 540 180 L 590 230" fill="none" stroke="#475467" stroke-width="4"
              stroke-linejoin="round" stroke-linecap="round" />
            <path d="M 595 240 L 575 265 L 585 285" fill="none" stroke="#D1D5DB" stroke-width="10"
              stroke-linejoin="round" stroke-linecap="round" />
            <path d="M 605 240 L 625 265 L 615 285" fill="none" stroke="#D1D5DB" stroke-width="10"
              stroke-linejoin="round" stroke-linecap="round" />
            <rect x="585" y="275" width="30" height="30" fill="#475467" stroke="#A48E69"
              stroke-width="4" rx="2" />
          </g>
          <path d="M 510 170 A 35 35 0 0 1 560 150" fill="none" stroke="#A48E69" stroke-width="3"
            stroke-linecap="round" />
          <circle cx="420" cy="290" r="8" fill="#8B3D3D" filter="url(#glow)" />
          <circle cx="540" cy="180" r="8" fill="#8B3D3D" filter="url(#glow)" />
          <circle cx="600" cy="240" r="5" fill="#8B3D3D" filter="url(#glow)" />
        </g>
      </svg>
    </div>

    <h1 class="brand-reveal-text" [class.is-visible]="showText()">
      @for (letter of titleLetters(); track $index) {
        <span [style.animation-delay.s]="$index * 0.1">
          @if (letter === ' ') {
            &nbsp;
          } @else {
            {{ letter }}
          }
        </span>
      }
    </h1>
  </div>
</div>

